import React, { ComponentType, useEffect } from 'react'
import { useAuth } from '@workos-inc/authkit-react'

export interface WithAuthenticationRequiredOptions {
  onRedirecting?: () => React.ReactElement
}

export function withAuthenticationRequired<P extends object>(
  WrappedComponent: ComponentType<P>,
  options: WithAuthenticationRequiredOptions = {}
) {
  return function WithAuthenticationRequired(props: P) {
    const { user, isLoading, signIn } = useAuth()
    const { onRedirecting = () => null } = options

    useEffect(() => {
      if (!isLoading && !user) {
        const searchParams = new URLSearchParams(window.location.search)
        const context = searchParams.get('context') ?? undefined
        signIn({ context })
      }
    }, [user, isLoading, signIn])

    if (isLoading || !user) {
      return onRedirecting()
    }

    return <WrappedComponent {...props} />
  }
}
